import { memo } from 'react';
import Menu from '@mui/material/Menu';
import Divider from '@mui/material/Divider';
import Item from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';
import { PopoverOrigin } from '@mui/material/Popover';
import { spacing, zIndex, ZIndexSizeType } from 'presentations/views/styles';
import styled from '@emotion/styled';

interface Props {
  options: any[];
  onSelect: any;
  onClose: any;
  className?: string;
  width?: number | string;
  maxWidth?: number | string;
  maxHeight?: number | string;
  anchor: any;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
  zIndex?: ZIndexSizeType;
}

const Component = memo((props: Props) => {
  const open = Boolean(props.anchor);

  return (
    <StyledMenu
      className={props.className}
      keepMounted
      anchorEl={props.anchor}
      open={open}
      // elevation={8}
      onClose={props.onClose}
      TransitionComponent={Fade}
      disableAutoFocusItem
      anchorOrigin={
        props.anchorOrigin || {
          vertical: 'bottom',
          horizontal: 'left',
        }
      }
      transformOrigin={
        props.transformOrigin || {
          vertical: 'top',
          horizontal: 'left',
        }
      }
      style={{
        zIndex: zIndex(props.zIndex ? props.zIndex : 1400),
      }}
      PaperProps={{
        style: {
          maxHeight: props.maxHeight,
          maxWidth: props.maxWidth,
          width: props.width,
          borderRadius: 8,
          boxShadow: '0px 8px 20px 0px rgba(0, 0, 0, 0.15)',
        },
      }}
    >
      {props.options.map((option, index) =>
        option.isDivider ? (
          <Divider key={index} />
        ) : (
          <Item key={index} onClick={(e) => props.onSelect(index, e)}>
            {option}
          </Item>
        ),
      )}
    </StyledMenu>
  );
});
const StyledMenu = styled(Menu)`
  hr.MuiDivider-root {
    margin: 0 ${spacing(16)};
  }
`;
export default Component;
